import styled from '@emotion/styled';
import { Row, Col, Divider } from 'antd';

export const GroupBlock = styled.div`
  margin-top: 1em;
  &:not(:first-of-type) {
    margin-top: 3.5em;
  }
`;

export const NotificationRow = styled(Row)`
  margin-top: 17px;
`;

export const CustomDivider = styled(Divider)`
  margin: 2px 0;
`;

export const CenteredCol = styled(Col)`
  display: flex;
  justify-content: center;
`;
